import type { Header } from "@tanstack/react-table";

import { ArrowLongDownIcon, ArrowLongUpIcon, ArrowsUpDownIcon } from "~/ui";
import type { Styled } from "~/utils";

interface SortIconProps<TData> extends Styled {
  header: Header<TData, unknown>;
}

export const SortIcon = <TData,>({
  className,
  header,
}: SortIconProps<TData>) => {
  const sortDirection = header.column.getIsSorted();
  if (sortDirection === "asc") return <ArrowLongUpIcon className={className} />;
  if (sortDirection === "desc")
    return <ArrowLongDownIcon className={className} />;
  return <ArrowsUpDownIcon className={className} />;
};
